<template>
  <div class="footer">
    <div class="footer__container container">
      <div class="footer__items">
        <div class="footer__item">
          <div class="footer__social">
            <a
              v-for="item in socials"
              :key="item.icon"
              class="footer__social-item"
              :href="item.link"
              target="_blank"
            >
              <Icon :name="item.icon" />
            </a>
          </div>
        </div>
        <div class="footer__item footer__copyright">
          {{ copyright }}
          <template
            v-for="(link, i) in links"
          >
            &nbsp;|&nbsp;
            <RrLink
              :key="i"
              class="footer__link"
              :text="link.text"
              :href="link.link"
              target="_blank"
              variant="inherit"
              size="sm"
            ></RrLink>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RrLink from '@rr-component-library/link/src/main'

export default {
  name: 'FooterTopliga',
  components: {
    RrLink
  },
  data () {
    return {
      year: new Date().getFullYear(),
      data: {
        copyright: '© Интернет - магазин TopLiga в Краснодаре',
        links: [
          {
            text: 'Публичная оферта',
            link: 'https://topliga.ru/company/oferta/'
          }
        ],
        socials: [
          {
            icon: 'vkontakte',
            link: 'https://vk.com/topligarun'
          },
          {
            icon: 'telegram',
            link: 'https://t.me/topligarun'
          },
          {
            icon: 'youtube',
            link: 'https://www.youtube.com/channel/UCs3bxjNOOq0w9LgwgDChUiw'
          }
        ]
      }
    }
  },
  computed: {
    copyright () {
      return this.data.copyright || ''
    },
    socials () {
      return this.data.socials || []
    },
    links () {
      return this.data.links || []
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: $color-dark;
  color: map-get($color-neutral-white, 65);
  padding: 20px 0;
  position: relative;
  margin-top: auto;

  &__items {
    text-align: center;
    margin: -16px -16px 0;

    @media (min-width: breakpoint(sm)) {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }

    @media (min-width: breakpoint(md)) {
      margin-left: -20px;
      margin-right: -20px;
    }

    @media (min-width: breakpoint(lg)) {
      flex-wrap: nowrap;
      text-align: left;
      margin-top: 0;
    }
  }

  &__item {
    flex: 0 0 auto;
    max-width: 100%;
    margin-top: 16px;
    padding: 0 16px;

    @media (min-width: breakpoint(md)) {
      padding: 0 20px;
    }

    @media (min-width: breakpoint(lg)) {
      margin-top: 0;
    }
  }

  &__copyright {
    @include text-sm;
    width: 100%;
    flex-shrink: 1;
    min-width: 0;

    @media (min-width: breakpoint(lg)) {
      order: -1;
    }
  }

  &__social {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: -8px;
  }

  &__social-item {
    display: block;
    width: 32px;
    height: 32px;
    color: inherit;
    margin-right: 8px;
    padding: 6px;
    max-width: 100%;
    transition: $transition-default;

    &:hover, &:focus {
      color: $color-white;
    }

    .rr-icon {
      display: block;
    }
  }

  &__link {
    color: $color-white;
  }
}
</style>
